<p-dialog
    [visible]="visible()"
    (visibleChange)="handleVisibleChange($event)"
    [modal]="true"
    [closable]="true"
    [draggable]="true"
    [resizable]="false"
    [style]="{ width: '55vw', maxWidth: '780px' }"
    styleClass="excel-error-dialog">

    <ng-template pTemplate="header">
        <div class="excel-error-dialog__header">
            <span class="excel-error-dialog__title">
                {{ heading() || t('dialogs.excelUploadErrors', 'Upload Errors') }}
            </span>
            <p-button
                type="button"
                [label]="t('buttons.downloadExcel', 'Download Excel')"
                icon="pi pi-download"
                severity="success"
                size="small"
                (click)="downloadExcel()">
            </p-button>
        </div>
    </ng-template>

    @if (visible()) {
        @if (message()) {
            <div class="excel-error-dialog__message">{{ message() }}</div>
        }

        <p-table
            [value]="errors()"
            [scrollable]="true"
            scrollHeight="400px"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    @for (col of columns(); track col) {
                        <th class="excel-error-dialog__th">{{ col | uppercase }}</th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    @for (col of columns(); track col) {
                        <td class="excel-error-dialog__td">
                            <div class="excel-error-dialog__cell-scroll">{{ row[col] ?? '' }}</div>
                        </td>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="columns().length || 1" class="excel-error-dialog__empty">
                        {{ t('common.noDataFound', 'No data found') }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }
</p-dialog>
